export default {
  lang: 'Spanish',
  homeScreen: {
    title: 'Descubre grandes cosas',
    stayConnected: 'Mantente en contacto',
    comingSoon: 'Próximamente disponible',
    messages: 'Mensajes',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Vamos a ver si podemos encontrar un perfil existente para usted en nuestro sistema.',
      homeTitleSub:
        'Introduzca la dirección de correo electrónico que utiliza habitualmente para acceder a los programas de formaci',
      noAccount:
        'No se ha encontrado ninguna cuenta ({email}), inténtalo con otra dirección de correo electrónico o crea una cuenta ahora.',
      continueButton: 'Continuar',
      success:
        'Ha actualizado correctamente su cuenta. En breve será redirigido a la página de inicio.',
      successNewAccount:
        'Para completar su inscripción, recibirá un correo electrónico de confirmación para verificar su cuenta.',
      loginButton: 'Inicio de sesión',
      matchFound:
        'Hemos encontrado una coincidencia, por favor, introduzca su contraseña para continuar.',
      magicLink:
        'Inicie sesión a través de un enlace en su correo electrónico:',
      magicLinkButton: 'Solicitar Magic Link',
      magicLinkTitle:
        'Recibe un enlace directo en tu correo electrónico que te permitirá registrarte al instante.',
      otherEmailButton: 'Enviar',
      title:
        'Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.',
      titleIndustry:
        'Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.',
      register: 'Crear una cuenta',
      agent: 'Asesor de viajes',
      visitor: 'Visitante del sector',
      step1: 'Paso 1: Tipo de usuario',
      step2: 'Paso 2: Crear una cuenta',
      step3: 'Paso 3: Cree su perfil',
      marketingOptIn:
        '¿Está seguro de que no le interesa seguir vinculado al equipo de comercio de viajes de este programa?',
      optIn: 'Sí, me interesa',
      optOut: 'No me interesa',
      step2Sub1: 'Háblenos de usted',
      step2Sub2: 'Háblenos de su empresa',
      privacyHead: 'PREFERENCIAS DE COMUNICACIÓN',
      privacySub:
        'Marque las casillas que aparecen a continuación para asegurarse de que recibe comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de redes comerciales de viajes y apoyo a las ventas de TravPRO Mobile.',
      privacy:
        'Protegemos su privacidad y nunca vendemos, abusamos o traicionamos su confianza.',
      store: 'Descarga fácilmente este programa en tu tienda de aplicaciones:',
      powered: 'PODER DE',
      toastMessage: {
        forgotSuccess:
          'Le hemos enviado por correo electrónico un enlace para restablecer su contraseña. Serás redirigido a la página de inicio de sesión en 10 segundos.',
        emailNotExisting:
          'La dirección de correo electrónico que has introducido no existe.',
        magicLinkMessage:
          'Por favor, espera, te estamos registrando ahora mismo.',
        magicLinkError:
          'No hemos podido encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Será redirigido en 10 segundos.',
        magicLinkError1:
          'No hemos podido encontrar un token válido, por favor inicie sesión o solicite un nuevo enlace mágico. Si este problema persiste, póngase en contacto con nosotros en: info@travpromobile.com.',
        magicLinkError2:
          'No hemos podido encontrar su cuenta en nuestra base de datos, por favor inicie sesión manualmente. Será redirigido en 10 segundos.',
        magicLinkSuccess:
          'Comprueba tu correo electrónico en {email}. Tiene un enlace mágico que te registrará.',
        magicLinkErrorWait:
          'Por favor, espera 5 minutos entre peticiones de enlace mágico.',
        emailNotFoundError:
          'La dirección de correo electrónico que ha introducido no se encuentra en nuestros registros. Por favor, compruebe si hay errores ortográficos o cree una cuenta.',
      },
      errors: {
        zipCodeNotFound: 'Código postal no encontrado, inténtelo de nuevo',
        zipCodeOnlyNumbers: 'El código postal sólo puede contener números',
        password: 'Introduzca una contraseña',
        passwordNotMatching: 'Las contraseñas introducidas no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        emailExists:
          'Esta dirección de correo electrónico ya existe o no es válida. Inténtelo con otra dirección de correo electrónico o acceda a su cuenta.',
        fillInAllFields: 'Rellene todos los campos obligatorios',
        fillInEmail:
          'Por favor, introduzca su dirección de correo electrónico.',
        emailNotExisting:
          'La dirección de correo electrónico que ha introducido no existe.',
      },
      fields: {
        forgotSubCopy: '¿Has olvidado tu contraseña y quieres cambiarla? ',
        forgotSubCopy2:
          '¿Quiere saltarse la contraseña por completo? Le enviaremos un correo electrónico con un enlace mágico que le permitirá acceder automáticamente al programa. ',
        city: 'Ciudad',
        companyName: 'Nombre de la empresa',
        role: 'Su función',
        description: '¿Cuál describe mejor la actividad de su empresa?',
        country: 'País',
        password: 'Contraseña',
        passwordRegister: 'Elija una contraseña (mínimo 8 caracteres)',
        passwordConfirm: 'Confirmar contraseña',
        firstName: 'Nombre',
        lastName: 'Apellido (Familia)',
        agency: 'Nombre de su agencia',
        title: 'Su función (seleccione una)',
        company: 'Nombre de la empresa',
        select: 'Seleccione una opción',
        state: 'Estado',
        province: 'Provincia/Región/Estado',
        zipCode: 'Código postal',
        postalCode: 'Código postal',
        affiliate: '¿A qué grupo está afiliada su agencia PRINCIPAL?',
        hostAgency: '¿Su agencia de acogida?',
        executive: 'Ejecutivo',
        management: 'Gestión',
        marketing: 'Marketing',
        sales: 'Ventas',
        coordinator: 'Coordinador',
        opt: 'Manténgase en contacto con el equipo de comercio de viajes de este programa y reciba actualizaciones.',
        optMarketing:
          'Manténgase en contacto con TravPRO en relación con programas y eventos similares.',
        retail: 'Fachada de tienda',
        home: 'Agente a domicilio',
        independent: 'Contratista independiente',
        host: 'Organismo anfitrión',
        call: 'Centro de llamadas o agencia web',
        other: 'Otros',
        describes:
          '¿Qué es lo que mejor describe su actividad y la de su agencia?',
      },
    },
    title:
      'Programa de habilitación de ventas y capacitación profesional de viajes', // Específico del producto (texto TravPRO o texto ChannelPRO)
    forgot: '¿Olvidó su contraseña?',
    forgotCopy:
      'Proporcione la dirección de correo electrónico que utilizó cuando se registró en su cuenta de Finland Travel PRO. Le enviaremos un correo electrónico que le permitirá restablecer su contraseña.',
    country: 'País/Región *',
    select: 'Seleccione una opción a continuación',
    theme: '¿Cuál es el TEMA DEL PRODUCTO que vende principalmente? *',
    type: '¿Cuál es el TEMA DEL PRODUCTO que vende principalmente? *',
    businessType: 'Tipo de negocio *',
    welcome: {
      headerTop: 'Bienvenido a',
      headerBottom: 'Finland Travel Pro',
    },
    sellingPoints: {
      0: 'Aprende, ayuda a la promoción y venta',
      1: 'Formación multimedia en todos los dispositivos',
      2: 'Certificado de realización',
      3: 'Presentaciones de ventas',
      4: 'Materiales promocionales relevantes',
      5: 'Consejos y promociones de expertos',
      6: 'Directorio de productos en tiempo real',
      7: 'Últimas noticias y actualizaciones',
    },
    emailPrompt:
      'Introduce tu dirección de correo electrónico y contraseña para verificar que eres un profesional de viajes.',
    tAndC: {
      agree: 'Al continuar, aceptas nuestra',
      privacyPolicy: ' Política de privacidad',
      and: ' y ',
      termsConditions: 'Términos y condiciones',
    },
    fields: {
      agency: 'Agencia',
      email: 'Email',
      password: 'Contraseña*',
      passwordConfirm: 'Confirmar la contraseña *',
      firstName: 'Primer nombre *',
      lastName: 'Apellido, Apellido *',
      city: 'Ciudad*',
      agencyName: 'Nombre de agencia*',
      stateProvince: 'Provincia',
      required: 'Campo obligatorio',
      invalidEmail: 'Dirección de correo electrónico no válida',
      opt: '¡Mantenerse en contacto! ¡Sí, quiero suscribirme para recibir comunicaciones de Finland Travel PRO para mantenerme al día con noticias, eventos, incentivos, FAM y mucho más!',
      forgot:
        '¿Ha olvidado su contraseña? Haz clic en el botón de abajo y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    noAgent: {
      noAgentButton: 'No soy asesora',
      title: 'Gracias por tu interés en Finland Travel PRO.',
      messageWeb:
        'El contenido de este sitio web está destinado únicamente a los profesionales de viajes. Para obtener más información sobre Finlandia, visita:',
      messageMobile:
        'Parte del contenido de esta aplicación es exclusivo para agentes de viajes; puedes obtener una vista previa de lo que esta aplicación ofrece haciendo clic en Siguiente.',
      continue: 'Continuar',
      visitWebsite: 'Visita la página web',
    },
    newUser: 'Nuevo Usuario',
    register: 'Registro',
    registered: 'Este correo electrónico ya está registrado',
  },
  welcomeScreen: {
    title: 'Bienvenido a Finland Travel PRO',
    helloUser: 'Hola {{name}}',
    hello: 'Hola,',
    fromAgency: 'por {{agency}}',
    notUser: 'Sin {{name}}?',
    introOnline:
      '¡Fórmate online o descarga el contenido con antelación y así disponer de la formación en cualquier momento incluso sin conexión!',
    introOffline:
      'Ya has cargado la última versión. ¡Comienza la formación en cualquier momento o lugar!',
    startTraining: 'Comienza tú formación',
    continueTraining: 'Sigue aprendiendo',
    graduated: '¡Felicidades!',
    downloader: {
      preload: 'Descarga anticipada',
      stop: 'Detener',
      init: 'Iniciando…',
      lastUpdate: 'Última actualización:',
    },
  },
  directoryFilters: {
    cities: 'Filtrar por Ciudad',
    search: 'Buscar un producto',
    type: 'Filtrar por Tipo de Producto',
    reset: 'Restablecer Filtros >',
    tags: 'Filtrar por Etiquetas',
    months: 'Filtrar por Temporada',
    noResults: 'No se Encontraron Resultados',
    targetGroups: 'Filtrar por Grupo Objetivo',
    additional: 'Filtros Adicionales:',
    sustainable: 'Viaje Sostenible Finlandia',
    accessible: 'Accesible',
    results: 'Resultados',
  },
  directory: {
    city: 'Filtrar por Ciudad',
    search: 'Buscar un producto',
    product: 'Filtrar por tipo de producto',
    reset: 'Reiniciar filtro >',
    category: 'Filtrar por categoría',
    season: 'Filtrar por Temporada',
    noResults: 'No se encontraron resultados',
    target: 'Filtrar por grupo objetivo',
    additional: 'Filtros adicionales',
    sustainable: 'Viajes sostenibles en Finlandia',
    accessible: 'Accesible',
    results: 'Resultados',
  },
  contactView: {
    regions: {
      europe: 'Europa',
      northAmerica: 'Norteamérica',
      asiaPacific: 'Asia Pacific',
      fcb: 'FCB - Finland Convention Bureau',
    },
    jobTitles: {
      salesMarketing: 'Gerente de Ventas y Mercadeo',
      directorVisitFinland: 'Director de Visit Finland (Dach & Benelux)',
      specialist: 'Especialista',
      accountManager: 'Gerente de cuentas',
      advisor: 'Tutor',
      headVisitFinlandNorthAmerica: 'Jefe de Visit Finland Norteamérica',
      managerBusinessEvents: 'Gerente, Eventos Empresariales',
      seniorBusinessEvents: 'Especialista sénior en eventos empresariales',
    },
    countries: {
      gbIreland: 'Gran Bretaña e Irlanda',
      spainItaly: 'España e Italia',
      france: 'Francia',
      westEurope: 'Alemania, Austria, Suiza, Bélgica, Países Bajos, Luxemburgo',
      benelux: 'Dach, Benelux',
      rusiaCISBaltics: 'Rusia (San Petersburgo), CIS and países Balticos',
      rusiaCIS: 'Rusia & CIS',
      northAmerica: 'Norteamérica',
      japan: 'Japan',
      chinaSEAsia: 'China & El sudeste de Asia',
      southKorea: 'Corea del Sur',
      india: 'India & UAE',
      australia: 'Australia',
    },
  },
  trainingScreens: {
    start: 'Comenzar',
    continue: 'Más',
    review: 'Revisar',
    restart: 'Comenzar de nuevo',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% completado',
    unlock: 'El capítulo se desbloquea al completar el Capítulo X.',
    unlockSubtitle: 'Completa los capítulos y se desbloquearán los siguientes.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Más',
    endReached: 'Has llegado al final',
    retainEnd:
      'Usa la barra superior para navegar por este capítulo o presiona el botón Atrás para volver a la vista general.',
    watchListenRead: 'Ver, escuchar y leer más',
    trouble:
      'Vuelve a leer el contenido de las páginas anteriores e inténtalo de nuevo.',
    confirm: 'Confirma tu respuesta',
    choose: 'Por favor elige una respuesta',
    skip: 'Atrás >',
    viewAllTitle: 'Consejo de aprendizaje',
    viewAll:
      'Para ir a la página siguiente, haz clic en los iconos para ver el contenido adicional. Hemos reunido videos, mapas y otra información útil que creemos pueden ayudarte a convertirte en un experto en Finlandia.',
    fillBlanks: 'Rellena el espacio en blanco:',
    next: 'Próxima pregunta',
    retry: 'Intentar de nuevo',
    fastTrackText: {
      success:
        '¡Enhorabuena, has aprobado el curso Fast Track y has desbloqueado el resto de la formación!',
      failed:
        'Desafortunadamente, no aprobaste el curso Fast Track, ¡puedes continuar con la formación para obtener tu diploma!',
    },
    fastTrack: '¡Conviértete en una superestrella suiza de los viajes!',
    fastTrackExplanation:
      '¡Simplemente responde el cuestionario en las siguientes páginas y gana una plaza en un FAM a Suiza! Todas las respuestas a las preguntas del cuestionario se pueden encontrar de las siguientes maneras: El contenido que has aprendido en los módulos de Rail Europe y Suiza y en las siguientes páginas web: ¡Estudia estos recursos detenidamente antes de realizar el cuestionario! Solo aquellos agentes que obtengan la puntuación más alta tendrán la oportunidad de ganar una plaza en el FAM.',
    fastTrackButton:
      'Haz clic aquí para realizar el cuestionario de superestrellas suizas',
    grading:
      'Haz clic aquí para realizar el cuestionario Swiss Superstar Quiz. Tu calificación final es: {grade}%',
  },
  nav: {
    home: 'Inicio',
    train: 'Formulario',
    learn: 'Aprender',
    retain: 'Conservar',
    directory: 'Directorio',
    showRoom: 'Vitrinas',
    showcases: 'Vitrinas',
    promote: 'Aplicar',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Recompensa',
    media: 'Medios de comunicación',
    favorites: 'Favoritos',
    contact: 'Contacto',
    reportCard: 'Ver Diploma',
    accountSettings: 'Configuraciones de la cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Aprender',
    retain: 'Conservar',
    subapps: 'Visite los módulos de partners para Finlandia',
    maintrainings: 'Inicio',
    subtrainings: 'Módulos de Especialización',
  },
  pageDescriptions: {
    train: 'Obtener más información, participar y convertirse en un experto',
    showroom: 'Sala de exposiciones',
    retain:
      'El lugar del conocimiento combinado: utiliza este área para responder a una pregunta sobre un producto de manera experta o para realizar una presentación de ventas, en cualquier momento, en cualquier lugar y desde cualquier dispositivo.',
    promote:
      'Comparte estos artículos para generar interés e iniciar una conversación con clientes actuales y potenciales.',
    sell: 'Responde a las preguntas de tus clientes y cierra las ventas como un profesional con recursos integrales y soporte de ventas específico.',
    favorites: 'Ver tu contenido favorito personal',
    search: 'Ver todo el contenido',
    subapps: '',
    maintrainings:
      'Completa estos módulos esenciales para obtener tu certificado.',
    subtrainings: 'Infórmate sobre estos productos especificos',
  },
  general: {
    viewBadge: 'Ver',
    viewBadge2: 'Insignia',
    back: 'Atrás',
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Atrás',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Mostrar {tipo}',
    imageNotFound: 'Imagen no encontrada',
    noResultsFor: 'No se encontraron resultados para: {{query}}',
    noFavorites: 'Aún no tienes favoritos.',
    noMessages: '¡Aún no has recibido ningún mensaje!',
    resultsFor: 'Resultados para: {{consulta}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '¡404 Pagina no encontrada!',
    oops: 'UH oh...',
    overview: 'Volver a la página principal',
    complete: 'Continuar',
    courseComplete: '¡Capítulo completado!',
    chapterComplete: '¡Capítulo completado!',
    message: '{count} mensaje',
    messagePlural: '{count} mensaje',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Recopilación',
    layout: 'Diseño',
    web: 'Página web',
    pdf: 'PDF',
    carousel: 'Recopilación',
  },
  questions: {
    dials: 'Gira las esferas para que coincidan con la respuesta.',
    fitb: 'Rellenar los espacios en blanco)',
    flip: 'Cambia el número para que coincida con la respuesta.',
    multipleChoice: 'Selecciona las respuestas correctas)',
    slider:
      'Utiliza el control deslizante para seleccionar la respuesta correcta',
    map: 'Responde a la pregunta tocando la ubicación correcta en el mapa',
    dropdown: 'Escoger...',
    true: 'Verdadero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'De acuerdo',
    optout: 'Rechazar',
    settings: 'Configuración de privacidad',
    message:
      '¡No nos has dicho nada sobre tus preferencias de privacidad! De acuerdo; aunque queremos brindarte la mejor experiencia de Sales Companion.',
    disabled: 'Parece que has desactivado el uso de cookies.',
    use: 'El {{appName}} requiere el uso de cookies para ofrecerte la mejor experiencia.',
    details: '¿Para qué se utilizan las cookies?',
    enable: 'Ver {{appName}} cómo habilitar tus cookies.',
    here: 'Aquí',
  },
  notLoggedIn: {
    super: 'No te has identificado',
    title: 'Necesitas iniciar sesión para poder ver este contenido',
    guest: 'Invitado',
  },
  demo: {
    message:
      'Este página web es una demostración del producto final. Actualmente está en desarrollo y no está terminada.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este recurso en tus redes sociales favoritas!',
    download: 'Descargar',
  },
  sharing: {
    copyURL: 'Copiar link',
    copied: 'Copiado',
    emailSubject: 'Un recurso de Finlandia',
    emailCopy:
      'Espero que disfrutes este recurso de Finlandia. ¡Comuníquese y comencemos a planificar su próximo viaje!',
    videoEmailSubject: 'Disfruta este video de Finlandia',
    videoEmailCopy:
      'Espero que disfruten este video de Finlandia. ¡Comuníquese y comencemos a planificar su próximo viaje!',
    imageEmailSubject: 'Disfruta de esta imagen de Finlandia',
    imageEmailCopy:
      'Espero que disfruten de esta imagen de Finlandia. ¡Comuníquese y comencemos a planificar su próximo viaje!',
    twitterCopy: 'Descubre grandes cosas en Finlandia',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header:
      'Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa, simplemente visite tu tienda de aplicaciones y busca {appName} o haz clic en uno de los botones a continuación',
    benefits: {
      1: 'Aprende, promociona y vende  sobre la marcha',
      2: 'Formación multimedia en todos los dispositivos',
      3: 'Certificado de Finalización',
      4: 'Presentaciones de ventas',
      5: 'Materiales promocionales importantes',
      6: 'Directorio de productos en tiempo real',
      7: 'Últimas noticias y actualizaciones',
      header: 'Esto te da:',
    },
  },
  custom: {
    splitUsers: 'Soy un ...',
    brandAmbassador: 'Embajador de la marca',
    travelPro: 'Viaje profesional',
  },
  submit: 'Enviar',
  back: 'Atrás',
  close: 'Cerrar',
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
